// -----------------CODED BY ATIQUE-----------------------

import { MDBCard, MDBCardBody, MDBCardText, MDBCol, MDBRow } from "mdbreact";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import usePutAuthed from "../../helpers/hooks/usePutAuthed";
import dropdown from "../../dropdown.json";
import useDeleteAuthed from "../../helpers/hooks/useDeleteAuthed";
import { useHistory } from "react-router-dom";
import useGetAuthed from "../../helpers/hooks/useGetAuthed";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import ProposedChangesModal from "./Modals/ProposedChangesModal";
import toastr from "toastr";
import moment from "moment";
import ProposedHistoryModal from "./Modals/ProposedHistoryModal";
// import { initializeApp } from 'firebase/app'
// import 'firebase/messaging';

// import {initFirebaseBackend} from '../../helpers/firebase_helper'
// import { getMessaging, getToken } from 'firebase/messaging';
import { Sendrequest, getTokenFCM } from "../../messaging";
// import { sync } from "mkdirp";
import ImageUploadBox from "./extra Components/ImageUploadBox";
import ProposedHistoryModal2 from "./Modals/ProposedHistoryModal2";
import ProposedChangesModal2 from "./Modals/ProposedChangeModal2";

// import PushNotification from '../../components/firebase/PushNotification';

// import messaging from '../../messaging';

function LoanDetail2(props) {
  // get params
  const { id, loanId, isNotified } = useParams();
  console.log("isNotified", isNotified);

  const history = useHistory();

  // states
  const [event, setEvent] = useState("");
  const [feilds, setFeilds] = useState("");

  const [modal, setModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRevision, setIsResvision] = useState(false);
  const [revisionModal, setRevisionModal] = useState(false);
  const [revisionModalData, setRevisionModalData] = useState([]);
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [disabled, setDisabled] = React.useState(false);
  // use hooks
  const [getData, getError, getLoading, getCall] = useGetAuthed(
    `get_loan_application/${loanId}`,
    true,
    "loan"
  );
  const [call, data, error, loading] = usePutAuthed(
    `update_loan_application/${loanId}`,
    "loan"
  );
  const [deleteCall, deleteData, deleteError, deleteLoading] = useDeleteAuthed(
    `delete_loan_application/${loanId}`,
    "loan"
  );

  // Check bankAdmin token
  const bankAdmin = JSON.parse(localStorage.getItem("bankAdmin"));

  // functions
  const updateData = () => {
    call(feilds);
    setEvent("Updated");
  };

  const deleteFun = () => {
    deleteCall();
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const toggleRevision = () => {
    setRevisionModal(!revisionModal);
  };

  const toggleDeleteConfirmationModal = () => {
    setDeleteConfirmationModal(!deleteConfirmationModal);
  };

  const handleDeleteConfirmation = () => {
    toggleDeleteConfirmationModal();
    deleteFun();
  };

  const getOptions = (id) => {
    let option = [];
    dropdown.map((x) => {
      if (x.id === id) {
        option = x.list_english;
      }
    });
    return option;
  };

  // Messeging config

  useEffect(() => {
    if (getData) {
      Sendrequest();

      console.log(getData[0]["loan_application"]);
      setFeilds(getData[0]["loan_application"]);
      setIsLoading(true);
      console.log(
        !getData[0]["loan_application"]?.ismodified &&
          !getData[0]["loan_application"]?.user_response
      );

      if (getData[0]?.loan_application.loan_id !== loanId) {
        getCall();
      }
    }
  }, [getData, loanId]);

  useEffect(() => {
    if (error) {
      console.log("Data did not updated", error);
      toastr.error(error);
    }
  }, [error, deleteError]);

  useEffect(() => {
    if (data) {
      console.log({ data });
      setFeilds(data);
      if (event === "Rejected") {
        toastr.error(`Application has been ${event}`);
        return;
      }
    }
    if (deleteData) {
      console.log({ deleteData });
      toastr.success("Application has been deleted");
      history.goBack();
    }
    if (feilds?.ismodified) {
      setDisabled(true);
    }

    if (deleteError) {
      toastr.error(`${deleteError.detail}`, {});
    }
  }, [data, deleteData, deleteError]);

  console.log(getData, "ye hen get dataaa");
  return (
    <React.Fragment>
      <Container fluid>
        {/* <PushNotification/> */}
        <div className="page-content">
          <div className="align-items-end d-flex justify-content-between mb-3">
            <h4>Loan Application</h4>

            {/* update and delete buttons */}
            {!bankAdmin && (
              <div className="d-flex">
                <Button
                  className="mr-1"
                  color="none"
                  style={{
                    background: "rgb(221,248,238)",
                    color: "rgb(58, 216, 147)",
                    padding: "10px",
                    width: " 9.5rem",
                    fontSize: "0.8rem",
                    whiteSpace: "nowrap",
                  }}
                  disabled={!feilds?.ismodified && !feilds?.user_response}
                  onClick={toggleRevision}
                >
                  Revision History{" "}
                  <i
                    className="fas fa-file-alt"
                    style={{ fontSize: "0.9em" }}
                  ></i>
                </Button>{" "}
                <Button
                  className="mr-1"
                  color="none"
                  style={{
                    background: "rgb(221,248,238)",
                    color: "rgb(58, 216, 147)",
                    padding: "10px",
                    width: " 9.5rem",
                    fontSize: "0.8rem",
                    whiteSpace: "nowrap",
                  }}
                  onClick={() => {
                    if (feilds?.ismodified) {
                      toastr.warning(
                        "The previous proposed changes are still pending. Please wait for farmer response."
                      );
                    } else {
                      toggleModal();
                    }
                  }}
                >
                  Propose Changes{" "}
                  <i
                    className=" fas fa-pencil-alt"
                    style={{ fontSize: "0.9rem" }}
                  ></i>
                </Button>{" "}
                <Button
                  className=" mr-1"
                  color="none"
                  style={{
                    background: "rgb(251,231,233)",
                    color: "rgb(224,109,110)",
                    padding: "8px",
                    width: " 6rem",
                    fontSize: "0.8rem",
                    whiteSpace: "nowrap",
                  }}
                  onClick={toggleDeleteConfirmationModal}
                >
                  Delete{" "}
                  <i
                    className="fas fa-trash-alt"
                    style={{ fontSize: "0.8rem" }}
                  ></i>
                </Button>{" "}
              </div>
            )}
          </div>

          {/* Modal for the propsed changes */}
          {!getLoading && (
            // <ProposedChangesModal
            //   modal={modal}
            //   toggleModal={toggleModal}
            //   feilds={feilds}
            //   getOptions={getOptions}
            //   getCall={getCall}
            // />

            // Modal2 Re-Edit for the propsed changes by atique
            // --------------------ProposedChangesModal2--------------------------------
            <ProposedChangesModal2
              modal={modal}
              toggleModal={toggleModal}
              feilds={feilds}
              getOptions={getOptions}
              getCall={getCall}
            />
          )}

          {!getLoading && (
            // <ProposedHistoryModal
            //   modal={revisionModal}
            //   toggleModal={toggleRevision}
            //   loanId={loanId}
            // />

            // Modal2 Re-Edit for the propsed changes by atique
            // -------------------ProposedHistoryModal2-------------------
            <ProposedHistoryModal2
              modal={revisionModal}
              toggleModal={toggleRevision}
              loanId={loanId}
            />
          )}

          {!getLoading && (
            <Modal
              isOpen={deleteConfirmationModal}
              toggle={toggleDeleteConfirmationModal}
              className="modal-dialog-centered"
            >
              <ModalHeader toggle={toggleDeleteConfirmationModal}>
                <h3>Confirmation</h3>
              </ModalHeader>
              <ModalBody style={{ textAlign: "center" }}>
                <h5 style={{ fontWeight: "bold" }}>
                  Are you sure you want to delete this?
                </h5>{" "}
                <br />
                <span
                  style={{
                    color: "rgb(220,91,91)",
                    display: "inline-block",
                    width: "400px",
                  }}
                >
                  All the information related to this Loan Application will be
                  deleted.
                </span>
              </ModalBody>
              <ModalFooter className="d-block">
                <div className="row">
                  <div className="col text-center">
                    <Button
                      onClick={toggleDeleteConfirmationModal}
                      style={{
                        width: "100%",
                        borderRadius: "10px",
                        padding: "15px",
                        borderColor: "rgb(216, 72, 72)",
                        backgroundColor: "#fff",
                      }}
                    >
                      <span style={{ color: "rgb(216, 72, 72)" }}>Cancel</span>
                    </Button>
                  </div>
                  <div className="col text-center">
                    <Button
                      onClick={handleDeleteConfirmation}
                      style={{
                        width: "100%",
                        borderRadius: "10px",
                        padding: "15px",
                        backgroundColor: "rgb(216, 72, 72)",
                        borderColor: "rgb(216, 72, 72)",
                      }}
                    >
                      <span style={{ color: "#fff" }}>Delete</span>
                    </Button>
                  </div>
                </div>
              </ModalFooter>
            </Modal>
          )}
          {getLoading ? (
            <Card>
              <CardBody className="text-center">
                <Spinner className="mr-2" color="primary"></Spinner>
              </CardBody>
            </Card>
          ) : (
            <>
              <MDBCard style={{ borderRadius: "18px" }}>
                <MDBCardBody>
                  <div
                    style={{
                      border: "1px solid #ddd",
                      padding: "30px",
                      borderRadius: "10px",
                    }}
                  >
                    <div className="row">
                      <div className="col-10">
                        <h2>Application Information:</h2>

                        <div className="app-info-1st-row">
                          <MDBRow className="mt-5">
                            <MDBCol sm="auto" className="equal-col-10" key="1">
                              <MDBCardText>
                                <h5>Loan Id</h5>
                              </MDBCardText>
                              <Input
                                readOnly
                                className="text-muted"
                                style={{
                                  borderRadius: "7px",
                                  padding: "15px",
                                  height: "auto",
                                }}
                                value={feilds["loan_id"]}
                              ></Input>
                            </MDBCol>

                            <MDBCol sm="auto" className="equal-col-10" key="2">
                              <MDBCardText>
                                <h5>Date</h5>
                              </MDBCardText>

                              <Input
                                readOnly
                                className="text-muted"
                                style={{
                                  borderRadius: "7px",
                                  padding: "15px",
                                  height: "auto",
                                }}
                                value={moment(feilds["createdAt"]).format(
                                  "DD-MM-YYYY"
                                )}
                              />
                            </MDBCol>
                            <MDBCol sm="auto" className="equal-col-10" key="3">
                              <MDBCardText>
                                <h5>CNIC</h5>
                              </MDBCardText>

                              <Input
                                readOnly
                                className="text-muted"
                                style={{
                                  borderRadius: "7px",
                                  padding: "15px",
                                  height: "auto",
                                }}
                                value={feilds["cnic"]}
                              />
                            </MDBCol>
                            <MDBCol sm="auto" className="equal-col-10" key="4">
                              <MDBCardText>
                                <h5>Education</h5>
                              </MDBCardText>
                              <Input
                                readOnly
                                onChange={(e) => {
                                  setFeilds({
                                    ...feilds,
                                    education: e.target.value,
                                  });
                                }}
                                className="text-muted"
                                style={{
                                  borderRadius: "7px",
                                  padding: "15px",
                                  height: "auto",
                                }}
                                value={feilds["education"]}
                              />
                            </MDBCol>
                            {/* <MDBCol sm="auto" className="equal-col-10" key="5"> */}
                            {/* PEHLA ROW  */}
                            {/* </MDBCol> */}
                          </MDBRow>
                        </div>

                        <div className="app-info-2nd-row">
                          <MDBRow className="mt-4">
                            <MDBCol sm="auto" className="equal-col-2nd" key="1">
                              <MDBCardText>
                                <h5>Marital Status</h5>
                              </MDBCardText>
                              <Input
                                readOnly
                                onChange={(e) => {
                                  setFeilds({
                                    ...feilds,
                                    marital_status: e.target.value,
                                  });
                                }}
                                className="text-muted"
                                style={{
                                  borderRadius: "7px",
                                  padding: "15px",
                                  height: "auto",
                                }}
                                value={feilds["marital_status"]}
                              />
                            </MDBCol>
                            <MDBCol sm="auto" className="equal-col-2nd" key="2">
                              <MDBCardText>
                                <h5>Family Members</h5>
                              </MDBCardText>
                              <Input
                                readOnly
                                onChange={(e) => {
                                  setFeilds({
                                    ...feilds,
                                    family_members: e.target.value,
                                  });
                                }}
                                className="text-muted"
                                style={{
                                  borderRadius: "7px",
                                  padding: "15px",
                                  height: "auto",
                                }}
                                value={feilds["family_members"]}
                              />
                            </MDBCol>
                            <MDBCol sm="auto" className="equal-col-2nd" key="3">
                              <MDBCardText>
                                <h5>House Ownership</h5>
                              </MDBCardText>
                              <Input
                                type="text"
                                readOnly
                                onChange={(e) => {
                                  setFeilds({
                                    ...feilds,
                                    house_ownership: e.target.value,
                                  });
                                }}
                                className="text-muted"
                                style={{
                                  borderRadius: "7px",
                                  padding: "15px",
                                  height: "auto",
                                }}
                                value={feilds["house_ownership"]}
                              >
                                {getOptions(445).map((x) => {
                                  if (!bankAdmin)
                                    return (
                                      <option key={x} value={x}>
                                        {x}
                                      </option>
                                    );
                                })}
                              </Input>
                            </MDBCol>
                            <MDBCol sm="auto" className="equal-col-2nd" key="4">
                              <MDBCardText>
                                <h5>Agricultural Experience</h5>
                              </MDBCardText>
                              <Input
                                readOnly
                                onChange={(e) => {
                                  setFeilds({
                                    ...feilds,
                                    agri_experience: e.target.value,
                                  });
                                }}
                                className="text-muted"
                                style={{
                                  borderRadius: "7px",
                                  padding: "15px",
                                  height: "auto",
                                }}
                                value={feilds["agri_experience"]}
                              />
                            </MDBCol>
                          </MDBRow>
                        </div>

                        <div className="input-container">
                          <MDBRow className="mt-4">
                            <MDBCol sm="4">
                              <MDBCardText>
                                <h5>Previous Experience of Same Crop</h5>
                              </MDBCardText>
                              <Input
                                type="text"
                                readOnly
                                onChange={(e) => {
                                  setFeilds({
                                    ...feilds,
                                    previous_experience_with_same_crop:
                                      e.target.value,
                                  });
                                }}
                                className="text-muted"
                                style={{
                                  borderRadius: "7px",
                                  padding: "15px",
                                  height: "auto",
                                  width: "100%",
                                }}
                                value={
                                  feilds["previous_experience_with_same_crop"]
                                }
                              >
                                {getOptions(473).map((x) => {
                                  if (!bankAdmin)
                                    return (
                                      <option key={x} value={x}>
                                        {x}
                                      </option>
                                    );
                                })}
                              </Input>
                            </MDBCol>
                            <MDBCol sm="4" style={{ marginLeft: "0px" }}>
                              <MDBCardText>
                                <h5>Motorcycle Ownership</h5>
                              </MDBCardText>
                              <Input
                                readOnly
                                onChange={(e) => {
                                  setFeilds({
                                    ...feilds,
                                    motorcycle_ownership: e.target.value,
                                  });
                                }}
                                className="text-muted"
                                style={{
                                  borderRadius: "7px",
                                  padding: "15px",
                                  height: "auto",
                                  width: "100%",
                                }}
                                value={feilds["motorcycle_ownership"]}
                              />
                            </MDBCol>
                            <MDBCol sm="4" style={{ marginLeft: "0px" }}>
                              <MDBCardText>
                                <h5>Crop Insurance History</h5>
                              </MDBCardText>
                              <Input
                                type="text"
                                readOnly
                                onChange={(e) => {
                                  setFeilds({
                                    ...feilds,
                                    crop_insurance_history: e.target.value,
                                  });
                                }}
                                className="text-muted"
                                style={{
                                  borderRadius: "7px",
                                  padding: "15px",
                                  height: "auto",
                                  width: "100%",
                                }}
                                value={feilds["crop_insurance_history"]}
                              >
                                {getOptions(440).map((x) => {
                                  if (!bankAdmin)
                                    return (
                                      <option key={x} value={x}>
                                        {x}
                                      </option>
                                    );
                                })}
                              </Input>
                            </MDBCol>
                            {/* THIRD ROW */}
                            <div
                              // style={{ marginLeft: "90px" }}
                              style={{ marginLeft: "140px" }}
                              className="d-flex flex-sm-nowrap"
                            ></div>
                          </MDBRow>
                        </div>
                      </div>
                      <div
                        style={{
                          height: "110px",

                          position: "relative",
                        }}
                        className="col-2 d-flex "
                      >
                        <ImageUploadBox />
                      </div>
                    </div>
                  </div>
                </MDBCardBody>
              </MDBCard>

              {/* --------------LAND DETAILS CARD-------------- */}
              <div className="land-detail">
                <MDBCard style={{ borderRadius: "18px" }}>
                  <MDBCardBody>
                    <div
                      style={{
                        border: "1px solid #ddd",
                        padding: "30px",
                        borderRadius: "10px",
                      }}
                    >
                      <h2>Land Details:</h2>
                      <MDBRow className="mt-5">
                        <MDBCol sm="auto" className="equal-col" key="1">
                          <MDBCardText>
                            <h5>Land Ownership</h5>
                          </MDBCardText>

                          <Input
                            type="text"
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                land_ownership: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                              width: "100%",
                            }}
                            value={feilds["land_ownership"]}
                          >
                            {getOptions(449).map((x) => {
                              if (!bankAdmin)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                        <MDBCol sm="auto" className="equal-col" key="2">
                          <MDBCardText>
                            <h5>PLRA Registered</h5>
                          </MDBCardText>
                          <Input
                            type="text"
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                plra_registered: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                              width: "100%",
                            }}
                            value={feilds["plra_registered"]}
                          >
                            {getOptions(456).map((x) => {
                              if (!bankAdmin)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                        <MDBCol sm="auto" className="equal-col" key="3">
                          <MDBCardText>
                            <h5>Land Size Acres</h5>
                          </MDBCardText>
                          <Input
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                land_size_acres: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                              width: "100%",
                            }}
                            value={feilds["land_size_acres"]}
                          />
                        </MDBCol>
                        <MDBCol sm="auto" className="equal-col" key="4">
                          <MDBCardText>
                            <h5>Khasra No</h5>
                          </MDBCardText>
                          <Input
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                khasra_no: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                              width: "100%",
                            }}
                            value={feilds["khasra_no"]}
                          />
                        </MDBCol>
                        <MDBCol sm="auto" className="equal-col" key="5">
                          <MDBCardText>
                            <h5>Khewat No</h5>
                          </MDBCardText>
                          <Input
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                khewat_no: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                              width: "100%",
                            }}
                            value={feilds["khewat_no"]}
                          />
                        </MDBCol>
                      </MDBRow>
                    </div>
                  </MDBCardBody>
                </MDBCard>
              </div>

              {/* ------------------------CROP INFORMATION------------------------ */}
              <div className="crop-info">
                <MDBCard style={{ borderRadius: "18px" }}>
                  <MDBCardBody>
                    <div
                      style={{
                        border: "1px solid #ddd",
                        padding: "30px",
                        borderRadius: "10px",
                      }}
                    >
                      <h2>Crop Information:</h2>
                      <MDBRow className="mt-5">
                        <MDBCol sm="3">
                          <MDBCardText>
                            <h5>Desired Crop</h5>
                          </MDBCardText>
                          <Input
                            type="text"
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                desired_crop: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={feilds["desired_crop"]}
                          >
                            {getOptions(442).map((x) => {
                              if (!bankAdmin)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                        <MDBCol sm="3">
                          <MDBCardText>
                            <h5>Crop Sowing Month</h5>
                          </MDBCardText>
                          <Input
                            type="text"
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                crop_sowing_month: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={feilds["crop_sowing_month"]}
                          >
                            {getOptions(441).map((x) => {
                              if (!bankAdmin)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                        <MDBCol sm="3">
                          <MDBCardText>
                            <h5>Crop Harvest Month</h5>
                          </MDBCardText>
                          <Input
                            type="text"
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                crop_harvest_month: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={feilds["crop_harvest_month"]}
                          >
                            {getOptions(439).map((x) => {
                              if (!bankAdmin)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                        <MDBCol sm="3">
                          <MDBCardText>
                            <h5>Average Yield Per Acre Last Year</h5>
                          </MDBCardText>
                          <Input
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                avg_yield_per_acre_last_year: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={feilds["avg_yield_per_acre_last_year"]}
                          />
                        </MDBCol>
                      </MDBRow>
                    </div>
                  </MDBCardBody>
                </MDBCard>
              </div>

              {/* -------------------LIVESTOCK AND MACHINERY---------------------- */}

              <MDBCard style={{ borderRadius: "18px" }}>
                <MDBCardBody>
                  <div
                    style={{
                      border: "1px solid #ddd",
                      padding: "30px",
                      borderRadius: "10px",
                    }}
                  >
                    <h2>Livestock And Machinery:</h2>
                    <MDBRow className="mt-5">
                      <MDBCol md="4" sm="12" xs="12">
                        <MDBCardText>
                          <h5>Livestock Ownership</h5>
                        </MDBCardText>
                        <Input
                          readOnly
                          onChange={(e) => {
                            setFeilds({
                              ...feilds,
                              livestock_ownership: e.target.value,
                            });
                          }}
                          className="text-muted"
                          style={{
                            borderRadius: "7px",
                            padding: "15px",
                            height: "auto",
                          }}
                          value={feilds["livestock_ownership"]}
                        />
                      </MDBCol>
                      <MDBCol md="4" sm="12" xs="12">
                        <MDBCardText>
                          <h5>Agriculture Machinery Ownership</h5>
                        </MDBCardText>
                        <Input
                          readOnly
                          onChange={(e) => {
                            setFeilds({
                              ...feilds,
                              agricultural_machinery_ownership: e.target.value,
                            });
                          }}
                          className="text-muted"
                          style={{
                            borderRadius: "7px",
                            padding: "15px",
                            height: "auto",
                          }}
                          value={feilds["agricultural_machinery_ownership"]}
                        />
                      </MDBCol>
                      <MDBCol md="4" sm="12" xs="12">
                        <MDBCardText>
                          <h5>Rental Machinery Requirement</h5>
                        </MDBCardText>
                        <Input
                          type="text"
                          readOnly
                          onChange={(e) => {
                            setFeilds({
                              ...feilds,
                              rental_machinery_requirement: e.target.value,
                            });
                          }}
                          className="text-muted"
                          style={{
                            borderRadius: "7px",
                            padding: "15px",
                            height: "auto",
                          }}
                          value={feilds["rental_machinery_requirement"]}
                        >
                          {getOptions(475).map((x) => {
                            if (!bankAdmin)
                              return (
                                <option key={x} value={x}>
                                  {x}
                                </option>
                              );
                          })}
                        </Input>
                      </MDBCol>
                    </MDBRow>
                  </div>
                </MDBCardBody>
              </MDBCard>

              {/* -------------------------FINANCIAL DETAILS-------------------------- */}

              <MDBCard>
                <MDBCardBody>
                  <div
                    style={{
                      border: "1px solid #ddd",
                      padding: "30px",
                      borderRadius: "10px",
                    }}
                  >
                    <h2>Financial Details:</h2>
                    <MDBRow className="mt-5">
                      <MDBCol sm="6">
                        <MDBCardText>
                          <h5>Household Assets</h5>
                        </MDBCardText>
                        <Input
                          type="text"
                          readOnly
                          onChange={(e) => {
                            setFeilds({
                              ...feilds,
                              household_assets: e.target.value,
                            });
                          }}
                          className="text-muted"
                          style={{
                            borderRadius: "7px",
                            padding: "15px",
                            height: "auto",
                          }}
                          value={feilds["household_assets"]}
                        >
                          {getOptions(446).map((x) => {
                            if (!bankAdmin)
                              return (
                                <option key={x} value={x}>
                                  {x}
                                </option>
                              );
                          })}
                        </Input>
                      </MDBCol>
                      <MDBCol sm="6">
                        <MDBCardText>
                          <h5 style={{ whiteSpace: "nowrap" }}>
                            Produce Selling Medium
                          </h5>
                        </MDBCardText>
                        <Input
                          type="text"
                          readOnly
                          onChange={(e) => {
                            setFeilds({
                              ...feilds,
                              produce_selling_medium: e.target.value,
                            });
                          }}
                          className="text-muted"
                          style={{
                            borderRadius: "7px",
                            padding: "15px",
                            height: "auto",
                          }}
                          value={feilds["produce_selling_medium"]}
                        >
                          {getOptions(474).map((x) => {
                            if (!bankAdmin)
                              return (
                                <option key={x} value={x}>
                                  {x}
                                </option>
                              );
                          })}
                        </Input>
                      </MDBCol>
                    </MDBRow>
                  </div>
                </MDBCardBody>
              </MDBCard>

              {/* ---------------------------IRRIGATION AND TECHNONOLY----------------------- */}
              <div className="irrigation-tech">
                <MDBCard>
                  <MDBCardBody>
                    <div
                      style={{
                        border: "1px solid #ddd",
                        padding: "30px",
                        borderRadius: "10px",
                      }}
                    >
                      <h2>Irrigation And Technology:</h2>
                      <MDBRow className="mt-5">
                        <MDBCol sm="6">
                          <MDBCardText>
                            <h5>Type of Irrigation</h5>
                          </MDBCardText>
                          <Input
                            type="text"
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                type_of_irrigation: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={feilds["type_of_irrigation"]}
                          >
                            {getOptions(480).map((x) => {
                              if (!bankAdmin)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                        <MDBCol sm="6">
                          <MDBCardText>
                            <h5>Availability of Latest Irrigation Systems</h5>
                          </MDBCardText>
                          <Input
                            type="text"
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                availability_of_latest_irrigation_systems:
                                  e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={
                              feilds[
                                "availability_of_latest_irrigation_systems"
                              ]
                            }
                          >
                            {getOptions(436).map((x) => {
                              if (!bankAdmin)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                      </MDBRow>
                    </div>
                  </MDBCardBody>
                </MDBCard>
              </div>

              {/* ---------------------------UREA AND FERTILIZERS----------------------- */}
              <div className="urea-fertizer">
                <MDBCard>
                  <MDBCardBody>
                    <div
                      style={{
                        border: "1px solid #ddd",
                        padding: "30px",
                        borderRadius: "10px",
                      }}
                    >
                      <h2>Urea And Fertilizers:</h2>
                      <MDBRow className="mt-5">
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5>Required Urea Quantity</h5>
                          </MDBCardText>
                          <Input
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                required_urea_quantity: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={feilds["required_urea_quantity"]}
                          />
                        </MDBCol>
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5>Preferred Urea Brand</h5>
                          </MDBCardText>
                          <Input
                            type="text"
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                preferred_urea_brand: { name: e.target.value },
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={
                              feilds["preferred_urea_brand"]
                                ? feilds["preferred_urea_brand"].name
                                : ""
                            }
                          >
                            {getOptions(468).map((x) => {
                              if (!bankAdmin)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5>Required Dap Quantity</h5>
                          </MDBCardText>
                          <Input
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                required_dap_quantity: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={feilds["required_dap_quantity"]}
                          />
                        </MDBCol>
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5>Preferred Dap Brand</h5>
                          </MDBCardText>
                          <Input
                            type="text"
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                preferred_dap_brand: { name: e.target.value },
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={
                              feilds["preferred_dap_brand"]
                                ? feilds["preferred_dap_brand"].name
                                : ""
                            }
                          >
                            {getOptions(457).map((x) => {
                              if (!bankAdmin)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5>Preferred Zinc Quantity</h5>
                          </MDBCardText>
                          <Input
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                preferred_zinc_quantity: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={feilds["preferred_zinc_quantity"]}
                          />
                        </MDBCol>
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5>Preferred Zinc Brand</h5>
                          </MDBCardText>
                          <Input
                            type="text"
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                preferred_zinc_brand: { name: e.target.value },
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={
                              feilds["preferred_zinc_brand"]
                                ? feilds["preferred_zinc_brand"].name
                                : ""
                            }
                          >
                            {getOptions(471).map((x) => {
                              if (!bankAdmin)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                      </MDBRow>

                      <MDBRow className="mt-5">
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5>Preferred Sop Quantity</h5>
                          </MDBCardText>
                          <Input
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                preferred_sop_quantity: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={feilds["preferred_sop_quantity"]}
                          />
                        </MDBCol>
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5>Preferred Sop Brand</h5>
                          </MDBCardText>
                          <Input
                            type="text"
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                preferred_sop_brand: { name: e.target.value },
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={
                              feilds["preferred_sop_brand"]
                                ? feilds["preferred_sop_brand"].name
                                : ""
                            }
                          >
                            {getOptions(466).map((x) => {
                              if (!bankAdmin)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5>Preferred Np Quantity</h5>
                          </MDBCardText>

                          <Input
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                preferred_np_quantity: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={feilds["preferred_np_quantity"]}
                          />
                        </MDBCol>
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5>Preferred Np Brand</h5>
                          </MDBCardText>

                          <Input
                            type="text"
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                preferred_np_brand: { name: e.target.value },
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={
                              feilds["preferred_np_brand"]
                                ? feilds["preferred_np_brand"].name
                                : ""
                            }
                          >
                            {getOptions(462).map((x) => {
                              if (!bankAdmin)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5>Preferred Mop Quantity</h5>
                          </MDBCardText>

                          <Input
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                preferred_mop_quantity: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={feilds["preferred_mop_quantity"]}
                          />
                        </MDBCol>
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5>Preferred Mop Brand</h5>
                          </MDBCardText>

                          <Input
                            type="text"
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                preferred_mop_brand: { name: e.target.value },
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={
                              feilds["preferred_mop_brand"]
                                ? feilds["preferred_mop_brand"].name
                                : ""
                            }
                          >
                            {getOptions(460).map((x) => {
                              if (!bankAdmin)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                      </MDBRow>
                    </div>
                  </MDBCardBody>
                </MDBCard>
              </div>

              {/* ---------------------------PESTICIDES AND CHEMICALS----------------------- */}
              <div className="pesticide-chemical">
                <MDBCard>
                  <MDBCardBody>
                    <div
                      style={{
                        border: "1px solid #ddd",
                        padding: "30px",
                        borderRadius: "10px",
                      }}
                    >
                      <h2>Pesticides And Chemicals:</h2>
                      <MDBRow className="mt-5">
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5 style={{ width: "97%" }}>
                              Required Pesticides Quantity
                            </h5>
                          </MDBCardText>
                          <Input
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                required_pesticides_quantity: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={feilds["required_pesticides_quantity"]}
                          />
                        </MDBCol>
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5 style={{ width: "99%" }}>
                              Preferred Pesticides Brand
                            </h5>
                          </MDBCardText>
                          <Input
                            type="text"
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                preferred_pesticides_brand: {
                                  name: e.target.value,
                                },
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={
                              feilds["preferred_pesticides_brand"]
                                ? feilds["preferred_pesticides_brand"].name
                                : ""
                            }
                          >
                            {getOptions(464).map((x) => {
                              if (!bankAdmin)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5>Preferred Weedicide Quantity</h5>
                          </MDBCardText>

                          <Input
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                preferred_weedicide_quantity: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={feilds["preferred_weedicide_quantity"]}
                          />
                        </MDBCol>
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5>Preferred Weedicide Brand</h5>
                          </MDBCardText>
                          <Input
                            type="text"
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                preferred_weedicide_brand: {
                                  name: e.target.value,
                                },
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={
                              feilds["preferred_weedicide_brand"]
                                ? feilds["preferred_weedicide_brand"].name
                                : ""
                            }
                          >
                            {getOptions(469).map((x) => {
                              if (!bankAdmin)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5>Preferred Fungicide Quantity</h5>
                          </MDBCardText>
                          <Input
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                preferred_fungicide_quantity: e.target.value,
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={feilds["preferred_fungicide_quantity"]}
                          />
                        </MDBCol>
                        <MDBCol sm="2">
                          <MDBCardText>
                            <h5 style={{ width: "90%" }}>
                              Preferred Fungicide Brand
                            </h5>
                          </MDBCardText>
                          <Input
                            type="text"
                            readOnly
                            onChange={(e) => {
                              setFeilds({
                                ...feilds,
                                preferred_fungicide_brand: {
                                  name: e.target.value,
                                },
                              });
                            }}
                            className="text-muted"
                            style={{
                              borderRadius: "7px",
                              padding: "15px",
                              height: "auto",
                            }}
                            value={
                              feilds["preferred_fungicide_brand"]
                                ? feilds["preferred_fungicide_brand"].name
                                : ""
                            }
                          >
                            {getOptions(458).map((x) => {
                              if (!bankAdmin)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                      </MDBRow>
                    </div>
                  </MDBCardBody>
                </MDBCard>
              </div>

              {/* ---------------------------SEEDS INFORMATIONS----------------------- */}

              <MDBCard>
                <MDBCardBody>
                  <div
                    style={{
                      border: "1px solid #ddd",
                      padding: "30px",
                      borderRadius: "10px",
                    }}
                  >
                    <h2>Seeds Information:</h2>
                    <MDBRow className="mt-5">
                      <MDBCol sm="6">
                        <MDBCardText>
                          <h5>Required Seeds Quantity Kgs</h5>
                        </MDBCardText>
                        <Input
                          readOnly
                          onChange={(e) => {
                            setFeilds({
                              ...feilds,
                              required_seeds_quantity_kgs: e.target.value,
                            });
                          }}
                          className="text-muted"
                          style={{
                            borderRadius: "7px",
                            padding: "15px",
                            height: "auto",
                          }}
                          value={feilds["required_seeds_quantity_kgs"]}
                        />
                      </MDBCol>
                      <MDBCol sm="6">
                        <MDBCardText>
                          <h5>Preferred Seeds Company</h5>
                        </MDBCardText>
                        <Input
                          type="text"
                          readOnly
                          onChange={(e) => {
                            setFeilds({
                              ...feilds,
                              preferred_seeds_company: { name: e.target.value },
                            });
                          }}
                          className="text-muted"
                          style={{
                            borderRadius: "7px",
                            padding: "15px",
                            height: "auto",
                          }}
                          value={
                            feilds["preferred_seeds_company"]
                              ? feilds["preferred_seeds_company"].name
                              : ""
                          }
                        >
                          {getOptions(465).map((x) => {
                            if (!bankAdmin)
                              return (
                                <option key={x} value={x}>
                                  {x}
                                </option>
                              );
                          })}
                        </Input>
                      </MDBCol>
                    </MDBRow>
                  </div>
                </MDBCardBody>
              </MDBCard>
            </>
          )}
        </div>
      </Container>
    </React.Fragment>
  );
}

export default LoanDetail2;
